/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mcp_Server_Development_Architect_Output9Inputs */

const en_svc_mcp_server_development_architect_output9 = /** @type {(inputs: Svc_Mcp_Server_Development_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MCP architecture spec`)
};

const ar_svc_mcp_server_development_architect_output9 = /** @type {(inputs: Svc_Mcp_Server_Development_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مواصفة بنية MCP`)
};

const bn_svc_mcp_server_development_architect_output9 = /** @type {(inputs: Svc_Mcp_Server_Development_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MCP আর্কিটেকচার স্পেসিফিকেশন`)
};

const de_svc_mcp_server_development_architect_output9 = /** @type {(inputs: Svc_Mcp_Server_Development_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MCP-Architekturspezifikation`)
};

const es_svc_mcp_server_development_architect_output9 = /** @type {(inputs: Svc_Mcp_Server_Development_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Especificación de arquitectura MCP`)
};

const fr_svc_mcp_server_development_architect_output9 = /** @type {(inputs: Svc_Mcp_Server_Development_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spécification d'architecture MCP`)
};

const pt_svc_mcp_server_development_architect_output9 = /** @type {(inputs: Svc_Mcp_Server_Development_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Especificação de arquitetura MCP`)
};

const zh_svc_mcp_server_development_architect_output9 = /** @type {(inputs: Svc_Mcp_Server_Development_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MCP 架构规范`)
};

const tr_svc_mcp_server_development_architect_output9 = /** @type {(inputs: Svc_Mcp_Server_Development_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MCP mimarisi şartnamesi`)
};

const ru_svc_mcp_server_development_architect_output9 = /** @type {(inputs: Svc_Mcp_Server_Development_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Спецификация MCP-архитектуры`)
};

const pl_svc_mcp_server_development_architect_output9 = /** @type {(inputs: Svc_Mcp_Server_Development_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Specyfikacja architektury MCP`)
};

/**
* | output |
* | --- |
* | "MCP architecture spec" |
*
* @param {Svc_Mcp_Server_Development_Architect_Output9Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mcp_server_development_architect_output9 = /** @type {((inputs?: Svc_Mcp_Server_Development_Architect_Output9Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mcp_Server_Development_Architect_Output9Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mcp_server_development_architect_output9(inputs)
	if (locale === "bn") return bn_svc_mcp_server_development_architect_output9(inputs)
	if (locale === "de") return de_svc_mcp_server_development_architect_output9(inputs)
	if (locale === "es") return es_svc_mcp_server_development_architect_output9(inputs)
	if (locale === "fr") return fr_svc_mcp_server_development_architect_output9(inputs)
	if (locale === "pt") return pt_svc_mcp_server_development_architect_output9(inputs)
	if (locale === "zh") return zh_svc_mcp_server_development_architect_output9(inputs)
	if (locale === "tr") return tr_svc_mcp_server_development_architect_output9(inputs)
	if (locale === "ru") return ru_svc_mcp_server_development_architect_output9(inputs)
	if (locale === "pl") return pl_svc_mcp_server_development_architect_output9(inputs)
	return en_svc_mcp_server_development_architect_output9(inputs)
});
export { svc_mcp_server_development_architect_output9 as "svc_mcp-server-development_ARCHITECT_output" }